import React, { Component } from 'react';
import InputText from '../../commonModules/interface/form-input-inline';
import { Grid, Button, IconButton } from '@material-ui/core';
import { EditRounded } from '@material-ui/icons';
import { toast } from 'react-toastify';

class Funding extends Component {
    state = { 
        actual_email: "",
        email_ref: "",
        
        updateForm: false
    }
    componentDidMount() {
        this.getRefEmail()
    }
    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        })
    }
    getRefEmail = async () => {
        let req = await fetch("/crowdlending/email/ref",{
            method:"GET",
            headers: {
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
            },
            credentials: 'same-origin',
        })
        let res = await req.json()

        console.log("getRefEmail", {res});
        if(res.error){
            console.log("getRefEmail", res.error.error);
        } else {
            this.setState({
                actual_email: res.data.email
            })    
        }
    }
    
    handleSubmit = async () => {
        if(this.state.email_ref !== ""){
            let req = await fetch("/crowdlending/email/link",{
                method:"POST",
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify({email: this.state.email_ref}),
                credentials: 'same-origin',
            })
            let res = await req.json()

            console.log('===========SUBMIT EMAIL REF=====================');
            console.log({res});
            console.log('====================================');
            if(res.error){
                console.log('====================================');
                console.log(res.error.error);
                console.log('====================================');
                toast.error( res.error.error.message)
            } else {
                toast.success( "Compte enregistré")
                this.clearForms()
                this.getRefEmail()
            }
        }
    }
    clearForms = () => {
        this.setState({
            email_ref: "",
            updateForm: false
        })
    }
    
    render() {
        return (
            <div>
                <h3>Compte MySolarLending</h3>
                <hr/>
                <h4> Compte actuel : {this.state.actual_email || ""} 
                    <IconButton onClick={()=>this.setState({updateForm: true})} >
                        <EditRounded />
                    </IconButton>
                    {/* <i className="zmdi zmdi-edit c-blue" onClick={()=>this.setState({updateForm: true})} style={{paddingLeft: "10px", cursor:"pointer", fontSize:"20px" }}></i>  */}
                </h4>

                {this.state.updateForm && 
                <Grid container spacing={2}>
                    <Grid item sm={10} xs={12}>
                        <InputText 
                            name="email_ref" 
                            title="Email" 
                            placeholder="Email du compte MySolarLending"
                            value={this.state.email_ref} 
                            change={this.handleChange} 
                        />
                    </Grid>
                    <Grid item sm={2} xs={12}>
                        <Button variant="contained" color="secondary" onClick={this.handleSubmit}>
                            Valider
                        </Button>
                        
                    </Grid>
                </Grid>
                }
            </div>
        );
    }
}

export default Funding;